import {AfterViewInit, Component, ElementRef, EventEmitter, HostListener, OnInit, Output, Renderer2, ViewChild} from '@angular/core';
import {AuthenticationService} from '../../../services/authentication.service';
import {UserService} from '../../../services/user-services/user.service';
import {ActivatedRoute, Router, RouterLink, RouterLinkActive, RouterOutlet} from '@angular/router';
import {LocalSettingsService} from '../../../services/local-settings.service';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {SchoolService} from '../../../services/school.service';
import {Title} from '@angular/platform-browser';
import {GlobalConstantsComponent} from '../../global-constants/global-constants.component';
import {first, take} from 'rxjs/operators';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {AlertService} from '../../../services/alert.service';
import {DeviceDetectorService} from 'ngx-device-detector';
import {animate} from 'popmotion';
import {Location, NgClass, NgFor, NgIf, NgStyle} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {AlertComponent} from '../../components/ux/alert-component/alert-component.component';
import {MatIconModule} from '@angular/material/icon';
import {NotificationsComponent} from '../../components/ux/notifications/notifications.component';
import {PlatformService} from '../../../services/platform-service.service';
import {IconComponent} from '../../components/icons-svgs/icons-svgs.component';

@Component({
  selector: 'app-admin-sidenav',
  templateUrl: './admin-sidenav.component.html',
  styleUrls: ['./admin-sidenav.component.scss'],
  standalone: true,
  imports: [
    NgClass,
    RouterLink,
    NgIf,
    NgFor,
    RouterLinkActive,
    MatIconModule,
    NgStyle,
    AlertComponent,
    RouterOutlet,
    FormsModule,
    TranslateModule,
    NotificationsComponent,
    IconComponent,
  ],
})

export class AdminSidenavComponent implements OnInit, AfterViewInit {

  //mediaURL = GlobalConstantsComponent.mediaURL + 'icons/loading/';
  adminMenu = [
    {name: 'Accueil', icone: 'home', link: 'home'},
    {name: 'Users', icone: 'accessibility', link: 'users'},
    {name: 'Services', icone: 'dashboard', link: 'services'},
    {name: 'Messages', icone: 'question_answer', link: 'messagerie', disabled: true},
    {name: 'Calendrier', icone: 'insert_invitation', link: 'calendrier', disabled: true},
    {name: 'KPIs', icone: 'timeline', link: 'kpi', disabled: true},
    {name: 'Configuration', icone: 'settings', link: 'settings'},
  ];

  isAdminPanel = false;
  currentUser;
  school;
  mediaPath = GlobalConstantsComponent.mediaURL + 'schools/';
  currentPage;
  // Loader
  loading = false;


  // mobile navbar
  isMobile = false;

  // sidebar
  status = 'hide';
  hasBottomMargin = true;
  isNotProperty = true;
  isDisplayed = true;
  isBrowser;


  public marginPx: number | string = '';
  public contactFormUrl: string;
  @Output() langChanged = new EventEmitter<string>();


  @ViewChild('sidebar') sidebar: ElementRef;
  @ViewChild('pageContent') pageContent: ElementRef;
  currentLanguage: string = 'en';

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (event.target.innerWidth < 768) {
      this.status = 'hide';
    } else {
      if (event.target.innerWidth > 768 && (this.router.url.endsWith('discover') || this.router.url.endsWith('browse'))) {
        this.status = 'show';
      }
    }
  }

  constructor(
    private authenticationService: AuthenticationService,
    private userService: UserService,
    private router: Router,
    private _localSettings: LocalSettingsService,
    private route: ActivatedRoute,
    public translate: TranslateService,
    private schoolService: SchoolService,
    private titleService: Title,
    private modalService: NgbModal,
    private alertService: AlertService,
    private mobileDetector: DeviceDetectorService,
    private renderer: Renderer2,
    private location: Location,
    private platformService: PlatformService,
  ) {
    this.currentPage = this.router.url;
    this.isBrowser = this.platformService.isBrowserPlatform();
  }

  ngOnInit(): void {
    
  this.currentLanguage = this._localSettings.getLanguage();


    if (this.platformService.isBrowserPlatform()) {
      this.route.data.subscribe(data => {
        if (data.margin == true || data.margin == false) {
          this.hasBottomMargin = data.margin;
        }
      });
      this.isMobile = this.mobileDetector.isMobile();
      this.userService.isMobileUser = this.isMobile;

      //UTM
      this.route.queryParams.subscribe(params => {
        if (params && (params['utm_campaign'] || params['utm_source'] || params['utm_medium'])) {
          const utm = [
            { key: 'utm_campaign', value: params['utm_campaign'] ? params['utm_campaign'] : '' },
            { key: 'utm_source', value: params['utm_source'] ? params['utm_source'] : '' },
            { key: 'utm_medium', value: params['utm_medium'] ? params['utm_medium'] : '' },
          ];
          this._localSettings.setUtm(JSON.stringify(utm));
        }
      });

      if (this.authenticationService.currentUserValue) {
        // CAMPAIGN - voir si on peut pas le mettre dans le app.component
        this.route.queryParams.subscribe(params => {
          if (params && params['campaign']) {
            this._localSettings.setReferer(params['campaign']);
            this.userService.updateReferer(params['campaign']).subscribe();
          }
          if (params && params['click_id']) {
            this._localSettings.setClickid(params['clickid']);
          }
          if(this._localSettings.getClickid()){
            this.userService.updateClickid(this._localSettings.getClickid()).subscribe();
          }

          const utm = this._localSettings.getUtm();
          if(utm){
            this.userService.updateUtm(JSON.parse(utm)).subscribe();
          }
        });

        this.currentUser = this.userService.getInfos();
        if (this.router.url.startsWith('/admin')) {
          if (this.currentUser['isGhost']) {
            this.isAdminPanel = true;
          }
        } else {
          this.isAdminPanel = false;
          if (this.router.url.includes('/accommodation')) {
            this.isNotProperty = true;
            this.marginPx = 0;
          } else {
            this.marginPx = '';
          }
        }
        if (window.innerWidth > 768 && (this.router.url.endsWith('discover') || this.router.url.endsWith('browse'))) {
          this.status = 'show';
        }

        // School
        this._localSettings.currentSchoolSlug = this.currentUser.school.slug;
        if (this.currentUser.school) {
          this.setSchoolSetting(this.currentUser.school);
        } else {
          this.schoolService.getBySlug(this._localSettings.currentSchoolSlug)
            .pipe(take(1))
            .subscribe((data: any) => {
              this.setSchoolSetting(data);
            });
        }
      } else {
        this.currentUser = null;
        if (this.schoolService.getCurrent()) {
          this.school = this.schoolService.getCurrent();
        } else {
          this.schoolService.getBySlug('livinfrance').pipe(take(1)).subscribe((data: any) => {
            this.setSchoolSetting(data);
          });
        }
        if (this.router.url.includes('/accommodation')) {
          this.isNotProperty = true;
          this.marginPx = 0;
        } else {
          this.marginPx = '';
        }
      }

      let currentUrl = this.location.path();
      if (currentUrl.includes('/property/') || currentUrl.includes('/properties/') || currentUrl.includes('/list/') || currentUrl.includes('/blog') || currentUrl.includes('/news') || currentUrl.includes('/modeles')) {
        this.isNotProperty = false;
      } else {
        this.isNotProperty = true;
      }

      if (this.router.url.includes('/blog') || this.router.url.includes('/news') || this.router.url.includes('/modeles') || (this.isMobile && this.router.url.includes('/post-reservation'))) {
        this.isDisplayed = false;
      }
    }
    this.setContactFormUrl();
  }

  ngAfterViewInit(): void {
    if (this.platformService.isBrowserPlatform()) {
      this.location.onUrlChange(() => {
        if (this.pageContent) {
          this.pageContent.nativeElement.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
          });
        }
      });
// Suppression ciblée du chat hubspot
      const hubspotChat = document.getElementById('hubspot-messages-iframe-container');
      const router = this.router.url;
      if (hubspotChat) {
        if (router.includes('accommodation/informations') || router.includes('accommodation/payment') || router.includes('accommodation/pending')) {
          if (!this.isMobile) {
            this.checkHubspotCookie(hubspotChat);
          } else {
            hubspotChat.classList.add('mobile');
            hubspotChat.classList.add('hideHubSpot');
            // @ts-ignore
            window.HubSpotConversations.on('widgetClosed', event => {
              hubspotChat.classList.add('hideHubSpot');
              hubspotChat.classList.remove('showHubSpot');
              const fixed = document.getElementsByClassName('hiding_for_hubspot');
              if (fixed && fixed.length > 0) {
                for (let i = 0; i < fixed.length; i++) {
                  fixed[i].classList.remove('hide');
                }
              }
            });
          }

        } else {
          hubspotChat.classList.add('showHubSpot');
        }
      }
    }
  }

  // Quand cookie.onChanges sera supporté par safari, changé pour ça > https://developer.mozilla.org/en-US/docs/Mozilla/Add-ons/WebExtensions/API/cookies/onChanged
  private checkHubspotCookie(hubspotChat): void {
    setInterval(() => {
      const cookieArray = document.cookie.split(';');
      cookieArray.forEach(c => {
        if (c.includes('hs-messages-is-open')) {
          const value = c.split('=');
          if (value[1] == 'true') {
            hubspotChat.classList.add('showHubSpot');
            hubspotChat.classList.remove('hideHubSpot');
          } else {
            hubspotChat.classList.add('hideHubSpot');
            hubspotChat.classList.remove('showHubSpot');
          }
        } else {
          hubspotChat.classList.add('hideHubSpot');
        }
      });
    }, 100);
  }

  // LANGUAGE FUNCTIONS
  public useLanguage(language: string) {
    if (language != 'fr') {
      language = 'en';
    }
    this.translate.use(language);
    this._localSettings.setLanguage(language);
    this.modalService.dismissAll();
    this.setContactFormUrl();
    this.platformService.eventEmitter.emit(language);

    if (this.currentUser) {
      this.userService
        .update({textLanguage: language})
        .pipe(first())
        .subscribe(
          (data: any) => {
            if (data.status === 'error') {
              this.alertService.openSnackBar(data.data, 'snack-error');
            } else {
              this.userService.setInfo('textLanguage', language);
            }
          },
          (error) => {
            this.alertService.openSnackBar(error, 'snack-error');
          }
        );
    }
    if (!this.router.url.includes('/account')) {
        let currentUrl = this.router.url;
        currentUrl = currentUrl.replace(/\/(fr|en)/, '');
        const newUrl = `/${language}${currentUrl}`;
        this.router.navigate([newUrl]);
    }
  }


  open(content) {
    this.modalService.open(content, {centered: true});
  }

  getLanguageKey(language) {
    return 'COMMON.LANGUAGE_FROM_KEY.' + language;
  }

  logout() {
    this.authenticationService.logout();
    this.router.navigate([this.currentLanguage + '/' + this._localSettings.currentSchoolSlug + '/login']);
  }

  redirectToLogin() {
    this.router.navigate([this.currentLanguage + '/livinfrance/register'], {queryParams: {returnUrl: this.currentPage}});
  }

  goToDashboard() {
    this.router.navigate([this.currentLanguage +'/discover']);
  }

  displaySidebar(show: string, b?) {
    if (window.innerWidth > 768 && !(this.router.url.endsWith('discover') || this.router.url.endsWith('browse'))) {
      if (show == 'show') {
        if (b && b.className && typeof b.className === 'string' && b.className.includes('sidebar') && this.status == 'hide') {
          this.status = 'show';
          animate({
            from: '125px',
            to: '300px',
            type: 'spring',
            stiffness: 403.9,
            damping: 24,
            duration: 500,
            onUpdate: (value) => {
              this.renderer.setStyle(this.sidebar.nativeElement, 'width', value);
            }
          });
        }
      } else {
        this.status = 'hide';
        animate({
          from: '300px',
          to: '125px',
          type: 'spring',
          stiffness: 178.3,
          damping: 20,
          onUpdate: (value) => {
            this.renderer.setStyle(this.sidebar.nativeElement, 'width', value);
          }
        });
      }
    }
  }

  private setSchoolSetting(school) {
    this.schoolService.setCurrent(school);
    this.school = school;
    this.titleService.setTitle('LivinFrance - ' + school.name);
  }

  private setContactFormUrl(): void {
    this.contactFormUrl = 'https://form.typeform.com/to/Skse0ywG';
    if (this.translate.currentLang === 'fr') {
      this.contactFormUrl = 'https://form.typeform.com/to/vfP7UpuV';
    }
  }




}
